import { readLocalStorage, writeLocalStorage } from 'redux/saga/helpers/local-storage';
export var KEY_NAME = 'cpCookiePolicySeen';
export var hasSeenCookiePolicy = function hasSeenCookiePolicy() {
  return readLocalStorage(KEY_NAME, false);
};
export var set = function set() {
  var seen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return writeLocalStorage(KEY_NAME, seen);
};